import type { Features } from '@core/types/types.features';

export const PRO_FLAGS: Features[] = ['channel_beta'];
